import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { crearDepartamento } from "../../../services/departamento.service";
import { getAllPaises } from "../../../services/pais.service";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { FormHook } from "../../../components/molecules/FormHook";
import { FormDiv } from "../../../components/atoms/FormDiv";
import { SubmitButton } from "../../../components/atoms/SubmitButton";
import { FormInput } from "../../../components/molecules/FormInput";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";

export const CrearDepartamentoPage = () => {
  const navigate = useNavigate();
  const DIR_ICON_MAT = "img/iconos/titulo de docente (con la pizarra).svg";
  const [estaCargando, setEstaCargando] = useState(false);
  const [paises, setPaises] = useState([]);
  const [cargandoPaises, setCargandoPaises] = useState(true);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const cargarPaises = async () => {
      try {
        const data = await getAllPaises();
        setPaises(data || []);
      } catch (err) {
        showErrorAlert({ text: "Error al cargar los países" });
      } finally {
        setCargandoPaises(false);
      }
    };

    cargarPaises();
  }, []);

  const submit = async (data) => {
    setEstaCargando(true);
    try {
      await crearDepartamento({
        nombre: data.nombre,
        idPais: data.idPais,
      });
      showAlert({
        callback: () => navigate("/departamento"),
      });
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Error al crear el departamento";
      showErrorAlert({ text: errorMessage });
    } finally {
      setEstaCargando(false);
    }
  };

  return (
    <ContenedorPageTemplate dirIcono={DIR_ICON_MAT} titulo="Crear Departamento">
      <FormHook
        handleSubmit={handleSubmit}
        submit={submit}
        className="w-[min(100%,700px)] mx-auto"
      >
        <FormDiv>
          <FormInput
            id="nombre"
            label="Nombre del Departamento"
            type="text"
            placeholder="Nombre del departamento"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
              maxLength: {
                value: 60,
                message: "Súpero la cantidad máxima de 60 caracteres",
              },
              minLength: { value: 1, message: "Mínimo 1 caracter" },
            }}
            error={errors.nombre}
          />
          
          <div className="mb-4">
            <label htmlFor="idPais" className="block text-sm font-medium text-gray-700 mb-2">
              País
            </label>
            {cargandoPaises ? (
              <div className="text-gray-500">Cargando países...</div>
            ) : (
              <select
                id="idPais"
                {...register("idPais", {
                  required: { value: true, message: "Campo requerido" },
                })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-theme-blue focus:border-transparent"
              >
                <option value="">Seleccione un país</option>
                {paises.map((pais) => (
                  <option key={pais.idPais} value={pais.idPais}>
                    {pais.nombre}
                  </option>
                ))}
              </select>
            )}
            {errors.idPais && (
              <span className="text-red-500 text-sm mt-1">
                {errors.idPais.message}
              </span>
            )}
          </div>
        </FormDiv>
        <SubmitButton estaCargando={estaCargando} text="Guardar" />
      </FormHook>
    </ContenedorPageTemplate>
  );
};